import axios from "axios";
import { API } from "./api";

// Опрос фоновой ИИ-задачи: та же механика, что в студии (разбор/примерки)
export const pollJob = async (jobId, headers) => {
  const started = Date.now();
  let fails = 0;
  while (Date.now() - started < 420000) {
    await new Promise((r) => setTimeout(r, 3000));
    try {
      const { data } = await axios.get(`${API}/jobs/${jobId}`, { timeout: 20000, headers });
      fails = 0;
      if (data.status === "done") return data;
      if (data.status === "error") {
        throw { response: { status: 502, data: { detail: data.error } } };
      }
    } catch (err) {
      if (typeof err?.response?.data?.detail === "string") throw err;
      fails += 1;
      if (fails >= 10) throw err;
    }
  }
  throw {
    response: {
      status: 504,
      data: { detail: "Генерация заняла слишком много времени. Попробуйте ещё раз." },
    },
  };
};
